export const explore_city_events = {
  explore_city_page_load: {
    category: "User loads explore city page",
    action: "User navigates to explore city page",
    label: "explore-city-page-load",
  },
  explore_city_back_click: {
    category: "User navigates back to today page",
    action: "User clicks on back button",
    label: "explore-city-back-click",
  },
  today_zenvoya_assistance_back_click: {
    category: "Today",
    action: "User clicks back on Zenvoya Assistance",
    label: "today-zenvoya-assistance-back-click",
  },

  today_explore_city_send: {
    category: "Today",
    action: "User sends Explore City input",
    label: "today-explore-city-send",
  },
  today_zenvoya_assistance_send: {
    category: "Today",
    action: "User sends Zenvoya Assistance input",
    label: "today-zenvoya-assistance-send",
  },

};
